import { IconButton } from "@fluentui/react/lib/Button";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { IIconButtonWithTooltipProps } from "./IIconButtonWithTooltipProps";

export function IconButtonWithTooltip(props: IIconButtonWithTooltipProps): JSX.Element {
  const { tooltip, ...rest } = props;
  return (
    <TooltipHost content={tooltip}>
      <IconButton {...rest} />
    </TooltipHost>
  );
}
